import React from 'react';
import { ref, query, orderByChild, equalTo } from './supabaseDatabaseCompat';
import { supabaseAuth } from './supabaseAuth';

export let backend = {
    app: null,
    database: null,
    auth: supabaseAuth,
    appcat: null,
};

const createBackendStructure = (database, appcat) => ({
    app: null,
    database,
    auth: supabaseAuth,
    usersRef: ref(database, 'users'),
    companyDriversRef: (companyId) => query(ref(database, 'users'), orderByChild('company_id'), equalTo(companyId)),
    companyBookingsRef: (companyId) => query(ref(database, 'bookings'), orderByChild('company_id'), equalTo(companyId)),
    bookingRef: ref(database, 'bookings'),
    cancelreasonRef: ref(database, 'cancel_reason'),
    settingsRef: ref(database, 'settings'),
    smtpRef: ref(database, 'smtpdata'),
    smsRef: ref(database, 'smsConfig'),
    carTypesRef: ref(database, 'cartypes'),
    carTypesEditRef: (id) => ref(database, `cartypes/${id}`),
    promoRef: ref(database, 'promos'),
    promoEditRef: (id) => ref(database, `promos/${id}`),
    notifyRef: ref(database, 'notifications'),
    notifyEditRef: (id) => ref(database, `notifications/${id}`),
    addressRef: (uid, id) => ref(database, `savedAddresses/${uid}/${id}`),
    addressEditRef: (uid) => ref(database, `savedAddresses/${uid}`),
    singleUserRef: (uid) => ref(database, `users/${uid}`),
    driversRef: query(ref(database, 'users'), orderByChild('usertype'), equalTo('driver')),
    driversByCompanyRef: (companyId) => query(ref(database, 'users'), orderByChild('company_id'), equalTo(companyId)),
    singleBookingRef: (bookingId) => ref(database, `bookings/${bookingId}`),
    requestedDriversRef: (bookingId) => ref(database, `bookings/${bookingId}/requestedDrivers`),
    referralIdRef: (referralId) => query(ref(database, 'users'), orderByChild('referralId'), equalTo(referralId)),
    trackingRef: (bookingId) => ref(database, `tracking/${bookingId}`),
    tasksRef: () => query(ref(database, 'bookings'), orderByChild('status'), equalTo('NEW')),
    singleTaskRef: (uid, bookingId) => ref(database, `bookings/${bookingId}/requestedDrivers/${uid}`),
    bookingListRef: (uid, role, companyId) => (
        role === 'customer' ? query(ref(database, 'bookings'), orderByChild('customer'), equalTo(uid))
            : role === 'driver' ? query(ref(database, 'bookings'), orderByChild('driver'), equalTo(uid))
                : companyId && (role === 'fleetadmin' || role === 'companyadmin' || role === 'dispatcher') ? query(ref(database, 'bookings'), orderByChild('company_id'), equalTo(companyId))
                : role === 'fleetadmin' ? query(ref(database, 'bookings'), orderByChild('fleetadmin'), equalTo(uid))
                    : ref(database, 'bookings')
    ),
    chatRef: (bookingId) => ref(database, `chats/${bookingId}/messages`),
    withdrawRef: ref(database, 'withdraws'),
    languagesRef: ref(database, 'languages'),
    languagesEditRef: (id) => ref(database, `languages/${id}`),
    langEditRef: (id) => ref(database, `languages/${id}/keyValuePairs`),
    walletHistoryRef: (uid) => ref(database, `walletHistory/${uid}`),
    userNotificationsRef: (uid) => ref(database, `userNotifications/${uid}`),
    userRatingsRef: (uid) => ref(database, `userRatings/${uid}`),
    carsRef: (uid, role) => (
        role === 'driver' ? query(ref(database, 'cars'), orderByChild('driver'), equalTo(uid))
            : role === 'fleetadmin' ? query(ref(database, 'cars'), orderByChild('fleetadmin'), equalTo(uid))
                : ref(database, 'cars')
    ),
    carAddRef: ref(database, 'cars'),
    carEditRef: (id) => ref(database, `cars/${id}`),
    allLocationsRef: ref(database, 'locations'),
    userLocationRef: (uid) => ref(database, `locations/${uid}`),
    sosRef: ref(database, 'sos'),
    editSosRef: (id) => ref(database, `sos/${id}`),
    complainRef: ref(database, 'complain'),
    editComplainRef: (id) => ref(database, `complain/${id}`),
    paymentSettingsRef: ref(database, 'payment_settings'),
    usedreferralRef: ref(database, 'usedreferral'),
    appcat,
});

export const BackendProvider = ({ children, appcat }) => {
    backend = createBackendStructure({ provider: 'supabase' }, appcat);
    return <>{children}</>;
};
